import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { TIPS } from '../../../consts/tips';

import { CloneObject } from '../../../utils/helpers';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import { useLista } from '../../hooks/useLista';
import { InputLista, FormLabel, Modal, FormError } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import { isValidEmail, isValidUrl } from '../../../utils/validator';
import { TIPO_CONTACTO_EMAIL, TIPO_CONTACTO_TELEFONO, TIPO_CONTACTO_SITIO_WEB } from '../../../consts/contactoTypes';


const ContactoModal = (props) => {

  const entityInit = {
    id: 0,
    entidad: '',
    idEntidad: 0,
    idTipoContacto: 0,
    detalle: ''
  };

  //hooks
  const [state, setState] = useState({
    entity: entityInit,
    showInfo: false
  });

  const mount = () => {
    setState(prevState => {
      return {...prevState, entity: props.data.entity };
    });
    formSet({
      idTipoContacto: props.data.entity.idTipoContacto,
      detalle: props.data.entity.detalle
    });
  }
  useEffect(mount, [props.data.entity]);

  const [, getRowLista] = useLista({
    listas: ['TipoContacto'],
    onLoaded: (listas, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'TipoContacto',
      timeout: 0
    }
  });

  const [ formValues, formHandle, , formSet ] = useForm({
    idTipoContacto: 0,
    detalle: ''
  });

  const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

  //handles
  const handleClickAceptar = () => {
    if (validate()) {

      let row = CloneObject(state.entity);
      const idTipo = Number(formValues.idTipoContacto);
      row.idTipoContacto = idTipo;
      row.detalle = TIPO_CONTACTO_TELEFONO.includes(idTipo)
        ? formValues.detalle.replace(/[\s\-()]/g, '')
        : formValues.detalle;

      props.onConfirm(row);
    };
  };

  //funciones
  function getErrors() {

    const errors = {};

    const idTipo = Number(formValues.idTipoContacto);
    if (!Number.isInteger(idTipo) || idTipo <= 0) errors.idTipoContacto = VALIDATION_MESSAGE.REQUIRED_OPTION;
    if (formValues.detalle.length <= 0) errors.detalle = VALIDATION_MESSAGE.REQUIRED;

    return errors;
  }

  function getFormatErrors() {

    const errors = {};

    if (props.disabled) return errors;

    if (formValues.detalle.length <= 0) return errors;

    const idTipo = Number(formValues.idTipoContacto);

    if (TIPO_CONTACTO_EMAIL.includes(idTipo) && !isValidEmail(formValues.detalle)) {
      errors.detalle = 'Ingresá un correo válido';
    }

    const detalleNormalizado = formValues.detalle.replace(/[\s\-()]/g, '');
    if (TIPO_CONTACTO_TELEFONO.includes(idTipo) && !/^\+?[0-9]+$/.test(detalleNormalizado)) {
      errors.detalle = 'Solo números, con + opcional al inicio';
    }

    if (TIPO_CONTACTO_SITIO_WEB.includes(idTipo) && !isValidUrl(formValues.detalle)) {
      errors.detalle = 'Ingresá una URL válida';
    }

    return errors;
  }

  const getDescTipoContacto = (id) => {
    const row = getRowLista('TipoContacto', id);
    return (row) ? row.nombre : '';
  }

  const getPlaceholderDetalle = (idTipo) => {
    if (TIPO_CONTACTO_EMAIL.includes(idTipo)) return 'ejemplo@mail.com';
    if (TIPO_CONTACTO_TELEFONO.includes(idTipo)) return '+5491155555555';
    if (TIPO_CONTACTO_SITIO_WEB.includes(idTipo)) return 'https://sitio.com';
    return '';
  }

  function ToggleAccordionInfo() {
    setState(prevState => {
      return {...prevState, showInfo: !prevState.showInfo};
    });
  }
  
  const accordionClose = <span className="material-symbols-outlined search-i">chevron_right</span>
  const accordionOpen = <span className="material-symbols-outlined search-i">expand_more</span>

  return (
    <>

    <Modal
      size="lg"
      title={`Contacto: ${(state.entity.id > 0) ? `${getDescTipoContacto(state.entity.idTipoContacto)} ${state.entity.detalle}` : "Nuevo"}`}
      tipName={TIPS.NAME.MODALS.CONTACTO_MODAL}
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">
                
                <div className="col-12 col-lg-6">
                    <FormLabel htmlFor="idTipoContacto" required>Tipo de contacto</FormLabel>
                    <InputLista
                        name="idTipoContacto"
                        placeholder=""
                        className={`form-control ${errorOf('idTipoContacto') ? 'is-invalid' : ''}`}
                        value={ formValues.idTipoContacto }
                        onChange={({target}) => {
                          formSet({...formValues,
                            idTipoContacto: target.value,
                            detalle: ''
                          });
                        }}
                        disabled={props.disabled}
                        lista="TipoContacto"
                    />
                    <FormError message={errorOf('idTipoContacto')} />
                </div>
                <div className="col-12 col-lg-6">
                    <FormLabel htmlFor="detalle" required>Detalle</FormLabel>
                    <input
                        name="detalle"
                        type="text"
                        placeholder={getPlaceholderDetalle(Number(formValues.idTipoContacto))}
                        className={`form-control ${errorOf('detalle') ? 'is-invalid' : ''}`}
                        value={ formValues.detalle }
                        onChange={ formHandle }
                        maxLength="250"
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('detalle')} />
                </div>

                <div className="m-top-20 mb-3 col-12">
                  <div className='accordion-header'>
                    <div className='row'>
                      <div className="col-12" onClick={() => ToggleAccordionInfo()}>
                        <div className='accordion-header-title'>
                          {(state.showInfo) ? accordionOpen : accordionClose}
                          <h3 className={state.showInfo ? 'active' : ''}>Información adicional</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  {state.showInfo &&
                  <div className='accordion-body'>
                    <DataTaggerFormRedux
                        title="Información adicional de Contacto"
                        processKey={props.processKey}
                        entidad="Contacto"
                        idEntidad={state.entity.id}
                        disabled={props.disabled}
                    />
                  </div>
                  }
                </div>                

            </div>
      )}
      footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

ContactoModal.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

ContactoModal.defaultProps = {
  disabled: false
};

export default ContactoModal;